import * as stylex from "@stylexjs/stylex";
export const styles = {
  shell: {
    kAzted: "x1ov3xa9",
    k1xSpc: "xrvj5dj",
    kumcoG: "xvky93f x1s4i0j0",
    kGNEyG: "x7a106z",
    kWkggS: "xgn9fwb",
    kMwMTN: "xi77g9k",
    kMv6JI: "x1b5zmvi",
    $$css: true
  },
  header: {
    kVAEAm: "x7wzq59 xleceg0",
    k87sOh: "xmhk92p",
    kZKoxP: "xo4xgle xf95lq",
    kogj98: "xhifcr4",
    kmVPX3: "x1qhigcl",
    kWkggS: "x15qrdpe",
    kaIpWk: "xgqmno8",
    k1xSpc: "x78zum5 x1pbhmcb",
    kXwgrk: "xdt5ytf",
    kOIVth: "x33pbmt",
    $$css: true
  },
  brand: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1v2ro7d",
    kGuDYH: "x1i1m3gp",
    k63SB2: "x1s688f",
    kb6lSQ: "x1roq8pg",
    kybGjl: "x1hl2dhg",
    kMwMTN: "xi77g9k",
    $$css: true
  },
  nav: {
    k1xSpc: "x78zum5",
    kOIVth: "x167g77z",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  navLink: {
    kMwMTN: "x13bgds0",
    k8WAf4: "xp59q4u",
    kg3NbH: "xqin4a2",
    kybGjl: "x1hl2dhg",
    kaIpWk: "x4pepcl",
    kGuDYH: "xif65rj",
    kGzVvX: "x18xb2ua",
    kDPRdz: "x1q3twa2",
    k3Woio: "xk3ytqa",
    kiEn40: "x7s97pk",
    $$css: true
  },
  active: {
    kMwMTN: "x1dq48wr",
    kWkggS: "x6cx41",
    $$css: true
  },
  identity: {
    k8WAf4: "x1vvogim",
    kGuDYH: "x1urxdys",
    kMwMTN: "x13bgds0",
    $$css: true
  },
  main: {
    k7Eaqz: "xeuugli",
    kzqmXN: "xh8yej3",
    ks0D6T: "x1kvbfxc",
    kUOVxO: "xvueqy4",
    kmVPX3: "x1i7k47o x1bwrasj",
    $$css: true
  },
  pageHeading: {
    k1xSpc: "x78zum5",
    kGNEyG: "x7a106z",
    kjj79g: "x1qughib",
    kOIVth: "x1c1vhfx",
    k1K539: "x1chd833",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  title: {
    kGuDYH: "xcg35fi",
    kLWn49: "x1u7k74",
    kb6lSQ: "xipi2l9",
    k63SB2: "x1s688f",
    k1K539: "xod5an3",
    $$css: true
  },
  description: {
    kMwMTN: "x13bgds0",
    kGuDYH: "xjznd3k",
    kLWn49: "x1dbl2gt",
    ks0D6T: "x13w81kk",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  panel: {
    kWkggS: "x15qrdpe",
    kaIpWk: "xgqmno8",
    kmVPX3: "xggk2y7",
    k1K539: "x1hq5gj4",
    $$css: true
  },
  panelHeading: {
    kGuDYH: "xosj86m",
    k63SB2: "x1s688f",
    k1K539: "x1yztbdb",
    $$css: true
  },
  grid: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x4bqi9s x1s4i0j0",
    kOIVth: "x1665zp3",
    $$css: true
  },
  form: {
    k1xSpc: "xrvj5dj",
    kumcoG: "xcjjqqt x1nc4n6v",
    kOIVth: "x1c1vhfx",
    $$css: true
  },
  inputControl: {
    kWkggS: "xy82bpy",
    kVAM5u: "x1jk5187",
    kAzted: "x1ba4aug x17aqpur",
    kaIpWk: "x1q4ynmn",
    $$css: true
  },
  field: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x167g77z",
    kGuDYH: "x5g1e64",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  select: {
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1jk5187",
    kaIpWk: "x1q4ynmn",
    kWkggS: "xy82bpy",
    kmVPX3: "x7z7khe",
    kMv6JI: "xjb2p0i",
    kGuDYH: "x5g1e64 xq5v2hu",
    k63SB2: "x1pd3egz",
    kAzted: "x1ba4aug",
    $$css: true
  },
  full: {
    kBCFzs: "x1osaytk",
    $$css: true
  },
  formContainer: {
    keoZOQ: "x1sy10c2",
    $$css: true
  },
  headerButton: {
    kWkggS: "xy82bpy",
    kMwMTN: "xi77g9k",
    $$css: true
  },
  actions: {
    k1xSpc: "x78zum5",
    kOIVth: "x883omv",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    keoZOQ: "xw7yly9",
    $$css: true
  },
  notice: {
    kmVPX3: "x1tamke2",
    kaIpWk: "xixl9f9",
    kWkggS: "xy82bpy",
    kMwMTN: "xi77g9k",
    k1K539: "x1hq5gj4",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  error: {
    kmVPX3: "x1tamke2",
    kaIpWk: "xixl9f9",
    kWkggS: "x5t24o3",
    kMwMTN: "x19frl10",
    k1K539: "xieb3on",
    $$css: true
  },
  status: {
    k1xSpc: "x3nfvp2",
    k8WAf4: "x12ulsxz",
    kg3NbH: "x1q4txso",
    kaIpWk: "x1q4ynmn",
    kGuDYH: "x1urxdys",
    kWkggS: "xy82bpy",
    kMwMTN: "x13bgds0",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  applied: {
    kWkggS: "x142y7dc",
    kMwMTN: "x1ynqwjw",
    $$css: true
  },
  failed: {
    kWkggS: "x5t24o3",
    kMwMTN: "x19frl10",
    $$css: true
  },
  tableWrap: {
    kXHlph: "xw2csxc",
    k7Eaqz: "xeuugli",
    ks0D6T: "x193iq5w",
    $$css: true
  },
  table: {
    kzqmXN: "xh8yej3",
    k7Eaqz: "xzl8ltb",
    kLvRdT: "x1mwwwfo",
    k9WMMc: "xdpxx8g",
    kGuDYH: "xif65rj",
    $$css: true
  },
  th: {
    k8WAf4: "x10dr8xq",
    kg3NbH: "xqin4a2",
    kGuDYH: "x1urxdys",
    k63SB2: "x1s688f",
    kMwMTN: "x13bgds0",
    kWkggS: "xgn9fwb",
    $$css: true
  },
  td: {
    k8WAf4: "x1xn8qrt",
    kg3NbH: "xqin4a2",
    kXLuUW: "x16dsc37",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  code: {
    kMv6JI: "x17kntyo",
    kGuDYH: "x4z9k3i",
    kmVPX3: "x1tamke2",
    kaIpWk: "x4pepcl",
    kWkggS: "xy82bpy",
    kXHlph: "xw2csxc",
    kLWn49: "xwxc2jc",
    kqGvvJ: "x2i9t41",
    $$css: true
  },
  small: {
    kGuDYH: "x1urxdys",
    kMwMTN: "x13bgds0",
    kLWn49: "x1dbl2gt",
    $$css: true
  },
  empty: {
    k8WAf4: "xxtzvbg",
    k9WMMc: "x2b8uid",
    kMwMTN: "x13bgds0",
    $$css: true
  },
  login: {
    kzqmXN: "xh8yej3",
    ks0D6T: "x1bio8jh",
    kUOVxO: "xvueqy4",
    kmVPX3: "xggk2y7",
    $$css: true
  },
  loginShell: {
    kAzted: "x1ov3xa9",
    kWkggS: "xgn9fwb",
    kMwMTN: "xi77g9k",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    k8WAf4: "xd11lqx",
    $$css: true
  },
  navigation: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf xr28j4b",
    kUk6DE: "x845mor xd798rk",
    kAzted: "x2lwn1j",
    kORKVm: "x1odjw0f",
    kOIVth: "x1jnr06f",
    kwnvtZ: "xozqiw3 xntmjiz",
    $$css: true
  },
  drawerNavigation: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kwnvtZ: "xozqiw3",
    kOIVth: "x1jnr06f",
    k7Eaqz: "xeuugli",
    kVQacm: "x1rea2x4",
    $$css: true
  },
  sidebarFooter: {
    kmuXW: "x2lah0s",
    keoZOQ: "xr1yuqi",
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "xou54vl",
    $$css: true
  },
  brandSubtitle: {
    k1xSpc: "x1lliihq",
    kGuDYH: "x4z9k3i",
    kMwMTN: "x13bgds0",
    k63SB2: "xo1l8bm",
    kb6lSQ: "x12oo3zp",
    keoZOQ: "x7r5mf7",
    $$css: true
  },
  loginBrand: {
    k1K539: "x1iymm2a",
    $$css: true
  },
  primaryLink: {
    k1xSpc: "x3nfvp2",
    k8WAf4: "x10dr8xq",
    kg3NbH: "x12j899k",
    kaIpWk: "x4pepcl",
    kWkggS: "x1ewilqj",
    kMwMTN: "x17wrial",
    kybGjl: "x1hl2dhg",
    k63SB2: "x1s688f",
    $$css: true
  }
};